import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';

/**Local files */
import { orders } from '../utils/index';

@Injectable()
export class ScheduleQueryService {

  ordersValues = orders;

  public FIRST_SCHEDULE_REQUESTS: any;
  public NEXT_SCHEDULE_REQUESTS: any;

  public GET_ALLOCATED_ACCPETED_ORDERS_DATA: any;
  public GET_REQUEST_BY_ORDER_ID: any;

  public UPDATE_SCHEDULE_REQUEST: any;
  public GET_ALL_STATUS: any;
  public GET_ALL_STATUS_WITH_DELETE: any;
  public GET_ALL_STATUS_BY_ROLE_ID: any;
  public CREATE_STATUS_BY_ORDERID: any;

  public GET_ID_FROM_ORDERID: any;
  public UPDATE_SCHEDULE_REQUEST_BY_NODE_ID: any;
  public GET_ALL_SCHEDULE_REQUESTS_QUERY: any;
  public GET_ALL_SCHEDULE_REQUESTS_LIMIT: any;

  constructor(public apollo: Apollo) {

    /*Get five schedules data */
    this.FIRST_SCHEDULE_REQUESTS = gql`
          query {
            allScheduleRequests(first:20,orderBy:CREATED_AT_DESC) {
                  edges {
                    node {
                      scheduleRequestDate
                      additionalShare
                      orderId
                      contactName
                      contactEmail
                      contactPhone
                      createdAt
                      buyerProperty
                      scheduleRequestId
                    }
                    cursor
                  }
                  pageInfo {
                    startCursor
                    endCursor
                    hasNextPage
                  }
                  totalCount
                }
          }
          `;

    /*Get last schedules data */
    this.NEXT_SCHEDULE_REQUESTS = gql`
    query GetOrders($cursor:Cursor!) {
      allScheduleRequests(after:$cursor,first:20,orderBy:CREATED_AT_DESC) {
            edges {
              node {
                scheduleRequestDate
                additionalShare
                orderId
                contactName
                contactEmail
                contactPhone
                createdAt
              }
              cursor
            }
            totalCount
            pageInfo {
                    startCursor
                    endCursor
                    hasNextPage
            }
          }
    }
    `;

    /*get all orders based on address*/
    this.GET_ALLOCATED_ACCPETED_ORDERS_DATA = gql`
          query GetOrders($acceptedBy:UUID!) {
              allScheduleRequests(orderBy:ORDER_ID_DESC,condition: {acceptedBy:$acceptedBy})
                {
                          edges {
                              node {
                                  orderId
                                      startAt
                                      endAt
                                      scheduleRequestDate
                                      createdAt
                                      buyerProperty
                                      statusId
                                      acceptedBy
                                      scheduleRequestId
                                      declineReason
                                      inspectionReportsSrcByScheduleRequestId {
                                        reportSolutionMastersByInsReportId(condition:{acceptStatus:true}) {
                                          edges {
                                            node {
                                              createdAt
                                              insReportId
                                              reviewId
                                              acceptStatus
                                              allocated
                                              orderId
                                              expectedDate
                                              buyerProperty
                                              reviewedBy
                                            reportReviewDetailByReviewId {
                                              categoryId
                                              subCategoryId
                                              categoryName
                                              subCategoryName
                                              totalCost
                                            }
                                            }
                                          }
                                        }

                                      }

                                }
                            }
                }
        }
          `;

    /*Get node Id of selected Order from ScheduleRequests*/
    this.GET_REQUEST_BY_ORDER_ID =
      gql`
                query currentScheduleRequests($orderId:Int){
                    allScheduleRequests(condition:{orderId:$orderId}) {
                    edges {
                    node {
                        orderId
                        nodeId
                        startAt
                        endAt
                        scheduleRequestDate
                        createdAt
                        buyerProperty
                        statusId
                        acceptedBy
                        acceptedDate
                        declineReason
                        contactName
                        contactEmail
                        contactPhone
                        completedat
                        scheduleRequestDate
                        nodeId
                        userRole
                        agentName
                        agentEmail
                        isOccupied
                        workContactName
                        workContactEmail
                        workContactPhone
                        wcRole
                        buyerAgentName
                        sellerAgentName
                        closingDate
                        workBeginDate
                        closingName
                        closingPhone
                        responsibleRole
                        isPrior
                        isPaymentClosed
                        additionalWork
                        signDate
                        additionalShare
                        progressContact
                        paymentContact
                        scheduleInfo
                        paymentEmail
                        paymentPhone
                        quoteImages
                        signImages
                        proSolution
                        descIssue
                        costToClient
                        statusChangeAt
                    }
                    }
                }
                }
      `;
    /*Update ScheduleRequests by node id from pro assign */
    this.UPDATE_SCHEDULE_REQUEST =
      gql`
                mutation updatequery($input:UpdateScheduleRequestInput!){
                    updateScheduleRequest(input:$input){
                    scheduleRequest {
                    statusId
                    }
                    }
                }
                `;
    /*Update ScheduleRequests by node id form Drop down*/

    this.UPDATE_SCHEDULE_REQUEST_BY_NODE_ID = gql`
    mutation updatequery($input:UpdateScheduleRequestInput!){
      updateScheduleRequest(input:$input){
      scheduleRequest {
      statusId
      }
      }
    }
    `;


    this.GET_ALL_STATUS = gql`
    query allStatuses{
      allStatuses(filter: {availableStatus: {equalTo: true}}){
        nodes{
          nodeId
          statusId
          statusName
          createat
          availableStatus
          displayStatus
          statusColor
        }totalCount
      }
    }`;

    this.GET_ALL_STATUS_WITH_DELETE = gql`
    query allStatuses {
      allStatuses {
        nodes {
          nodeId
          statusId
          statusName
          createat
          availableStatus
          displayStatus
          statusColor
        }
        totalCount
      }
    }`;

    this.GET_ALL_STATUS_BY_ROLE_ID = gql`
    query allStatuses($roleId: UUID!, $userId: UUID!) {
      allStatuses(filter: {availableStatus: {equalTo: true}}) {
        nodes {
          nodeId
          statusId
          statusName
          createat
          availableStatus
          displayStatus
          statusColor
          roleStatusPermissionsByStatusId(filter: {roleId: {equalTo: $roleId}, isDeletedYn: {equalTo: false}}) {
            nodes {
              roleId
            }
          }
          userStatusPermissionsByStatusId(filter: {userId: {equalTo: $userId}, isDeletedYn: {equalTo: false}}) {
            nodes {
              userStatusPermissionId
              userId
              statusId
              isDeletedYn
            }
          }
        }
        totalCount
      }
    }`;

    this.CREATE_STATUS_BY_ORDERID = gql`
    mutation createOrderStatus($input:CreateOrderStatusInput!) {
      createOrderStatus(input:$input) {
           orderStatus {
           statusId
           orderId
           userId
          }
        }
      }
              `;
    this.GET_ID_FROM_ORDERID = gql`
    query getID($orderId:Int ){                           
      allOrderStatuses ( condition: {orderId: $orderId} ,orderBy:ID_DESC) {
          nodes{
            id
            orderId
            statusId
            userId
            id
            statusByStatusId{
              statusName
            }
            }
      }
    }
              `;

    this.GET_ALL_SCHEDULE_REQUESTS_QUERY = gql`
      query GetAllScheduleRequests($first: Int!, $after: Cursor) {
        allScheduleRequests(
          first: $first, 
          after: $after, 
          orderBy: CREATED_AT_DESC
        ) {
          edges {
            node {
              scheduleRequestDate
              additionalShare
              orderId
              contactName
              contactEmail
              contactPhone
              createdAt
              buyerProperty
              scheduleRequestId
              __typename
            }
            cursor
            __typename
          }
          pageInfo {
            startCursor
            endCursor
            hasNextPage
            hasPreviousPage
            __typename
          }
          totalCount
          __typename
        }
      }
    `;

      this.GET_ALL_SCHEDULE_REQUESTS_LIMIT = gql`
      query GetAllScheduleRequestsWithLimit($first: Int!) {
        allScheduleRequests(first: $first, orderBy: CREATED_AT_DESC) {
          nodes {
            scheduleRequestDate
            additionalShare
            orderId
            contactName
            contactEmail
            contactPhone
            createdAt
            buyerProperty
            scheduleRequestId
          }
          totalCount
        }
      }
    `;

  }
  /*Get all schedules data */
  GET_ALL_SCHEDULE_REQUESTS(from, cursor): any {
    console.log('from', from);
    return this.apollo.watchQuery({
      query: from == 'initial' ? this.FIRST_SCHEDULE_REQUESTS : this.NEXT_SCHEDULE_REQUESTS,
      variables:
      {
        "cursor": cursor,
      },
      fetchPolicy: 'network-only'
    });
  }

    GET_ALL_SCHEDULE_REQUESTSS(first: number = 100, after: string = '') {
    const variables: any = { first: first };
    
    // Only add the after parameter if it's a valid cursor (not empty string)
    if (after && after.trim() !== '' && after !== 'null' && after !== null) {
      variables.after = after;
    }

    return this.apollo.watchQuery({
      query: this.GET_ALL_SCHEDULE_REQUESTS_QUERY,
      variables: variables,
      fetchPolicy: 'network-only',
      errorPolicy: 'all'
    });
  }
  
  GET_ALL_SCHEDULE_REQUESTS_WITH_LIMIT(limit: number = 2000) {
    return this.apollo.watchQuery({
      query: this.GET_ALL_SCHEDULE_REQUESTS_LIMIT,
      variables: { first: limit },
      fetchPolicy: 'network-only',
      errorPolicy: 'all'
    });
  }

  /*Get allocated & accepted orders*/
  GET_ALLOCATED_ACCPETED_ORDERS(userId): any {
    return this.apollo
      .watchQuery({
        query: this.GET_ALLOCATED_ACCPETED_ORDERS_DATA
        ,
        variables:
        {
          "acceptedBy": userId,
        },
        fetchPolicy: 'network-only'
      });
  }

  /*Get node Id of selected Order from ScheduleRequests*/
  GET_REQUEST_STATUS_BY_ORDER_ID(orderId): any {
    return this.apollo
      .watchQuery({
        query: this.GET_REQUEST_BY_ORDER_ID
        ,
        variables:
        {
          "orderId": Number.parseInt(orderId)
        },
        fetchPolicy: 'network-only'
      });
  }

  /*Update ScheduleRequests by owner using node id*/
  UPDATE_REQUEST_STATUS_BY_OWNER(nodeId, userId): any {

    return this.apollo.mutate({
      mutation: this.UPDATE_SCHEDULE_REQUEST,
      variables: {
        "input": {
          "scheduleRequestPatch":
          {
            "statusId": 11,
            "acceptedBy": userId,
            "statusChangeAt": new Date() //after assign ,save date
          },
          "nodeId": nodeId
        }
      },
      fetchPolicy: 'no-cache'
    })
  }
  /*Update ScheduleRequests by own user using node id*/
  UPDATE_PROGRESS_STATUS(nodeId): any {
    return this.apollo.mutate({
      mutation: this.UPDATE_SCHEDULE_REQUEST,
      variables: {
        "input": {
          "scheduleRequestPatch":
          {
            "statusId": 6,
            "statusChangeAt": new Date(),
            "completedat": new Date()
          },
          "nodeId": nodeId
        }
      },
      fetchPolicy: 'no-cache'
    })

  }

  /*Update ScheduleRequests by owner using node id from drop down */
  UPDATE_REQUEST_STATUS_FROM_DROP_DOWN(nodeId, userRole, statusId): any {

    return this.apollo.mutate({
      mutation: this.UPDATE_SCHEDULE_REQUEST_BY_NODE_ID,
      variables: {
        "input": {
          "scheduleRequestPatch":
          {
            "statusId": statusId,
            "role": userRole,
            "statusChangeAt": new Date(),
          },
          "nodeId": nodeId
        }
      },
      fetchPolicy: 'no-cache'
    });
  }

  //get all status 
  GET_STATUS_ALL(): any {
    return this.apollo.watchQuery({
      query: this.GET_ALL_STATUS,
      fetchPolicy: 'network-only',
    });
  }

  GET_STATUS_ALL_WITH_DELETE(): any {
    return this.apollo.watchQuery({
      query: this.GET_ALL_STATUS_WITH_DELETE,
      fetchPolicy: 'network-only',
    });
  }

  GET_STATUS_ALL_BY_ID_CALL(roleId, userId): any {
    return this.apollo.watchQuery({
      query: this.GET_ALL_STATUS_BY_ROLE_ID,
      variables: {
        roleId: roleId,
        userId: userId
      },
      fetchPolicy: 'network-only',
    });
  }

  /*Create orderid status*/
  CREATE_STATUS(orderId, statusId, userId): any {

    return this.apollo.mutate({
      mutation: this.CREATE_STATUS_BY_ORDERID,
      variables: {
        "input": {
          "orderStatus": {
            "statusId": statusId,
            "orderId": orderId,
            "userId": userId,
          },
        },
      },
      fetchPolicy: 'no-cache'
    });
  }


  /** Get ID of Orderid in order status table  */
  GET_ID(orderId) {
    return this.apollo.watchQuery({
      query: this.GET_ID_FROM_ORDERID,
      variables:
      {
        orderId: orderId,
      },
      fetchPolicy: 'network-only'
    })

  }
}



// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/queryFiles/scheduleRequest.ts